import React from "react";
import {  FormContextConsumer } from "./FormContext";
import hoistNonReactStatics from "hoist-non-react-statics";

const withContext = Comp => {
  const hocComponent = props => {
    return (
      <FormContextConsumer>
        {context => {
                    
          return (
            <Comp
              {...props}              
              formContext={context}
            />
          );
        }}
      </FormContextConsumer>
    );
  };
  var componentDisplayName =
    Comp.displayName ||
    Comp.name ||
    (Comp.constructor && Comp.constructor.name) ||
    "Component";

  hocComponent.displayName = "withContext(" + componentDisplayName + ")";
  hoistNonReactStatics(hocComponent, Comp);

  return hocComponent;
};

export default withContext;
